
import Aux from "./../hoc/Auxiliary";
import Tabs from "../components/Tabs/Tabs";
import Links from "../components/Links/Links";
import News from "../components/News/News"
import Faq from "../components/Faq/Faq";
import Gallery from "./Gallery/Gallery";
import Icons from "../components/Icons/Icons";
import ContactUs from "../components/ContactUs/ContactUs";
import Footer from "../components/Footer/Footer"
import Form from "../components/Form/Form"
import Event from "../components/Event/Event"
import Collections from "../components/Collections/Collections";
import dataServices from "../common/dataServices";
import React from "react";
import ReactDOM from "react-dom"; 
import "./index.css";

class ModWebParts extends React.Component { 
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            webpartType:'',
            webpartLink:'',
            webpartLinkTitle:'',
            webpartLayout:'',
            webpartText:'',
            mobile:false,
            WpId:'',
            webPartNumber:0
        };
    }
   
    GetListItems(){
        const listName = this.props.webPartProperties.listName;  
        const wpid =this.props.webPartProperties.WpId; 
        const viewName =this.props.webPartProperties.listView; 
        const siteUrl = this.props.webPartProperties.site; 
        dataServices.getSPListItems(siteUrl,listName,viewName)
        .then((response)=> response.data)   
        .then(lsItemsResponse=>{
            var itemsData = JSON.parse(lsItemsResponse);
            this.setState(
                {
                    items: itemsData
                }
            )
            
        })
    }
    componentDidMount(){
        this.setState(
            {  
                webpartType: this.props.webPartProperties.type,
                webpartLink: this.props.webPartProperties.readMoreLink,
                webpartLinkTitle: this.props.webPartProperties.readMoreTitle,
                webpartTitle: this.props.webPartProperties.title,
                webpartLayout: this.props.webPartProperties.layout,
                webpartText: this.props.webPartProperties.ModText,
                tablet: window.innerWidth < 992,
                mobile: window.innerWidth < 768,
                WpId: this.props.webPartProperties.WpId,
                webPartNumber: this.props.webPartProperties.ModNumber
 
            }
        )
    //    console.log('GetListItems');
    //    debugger;
       this.GetListItems();
       
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }
    resize(){
        let tablet= window.innerWidth < 992;
        let mobile= window.innerWidth < 768;
        if(mobile !== this.state.mobile || tablet !== this.state.tablet){
            this.setState({mobile:mobile,
            tablet:tablet})
        }
    } 
    componentWillMount() {  
        
    }

    handleUserKeypress=(event)=>
    {
        const {key,keyCode}=event;
        //console.log(key);
        if(keyCode == 36)
        {
            var allElementsBut = Array.prototype.slice.call(document.querySelectorAll('.btn-link'));
            allElementsBut[0].focus();
        }
        if(keyCode == 35)
        {
            var allElementsBut = Array.prototype.slice.call(document.querySelectorAll('.btn-link'));
            // console.log(allElementsBut.length);
            // console.log(allElementsBut[allElementsBut.length-1]);
            allElementsBut[allElementsBut.length-1].focus();
        }
        //event.preventDefault();
    }

    render() {
        let selectedWP=null;
       
        if(this.state.webpartType=='Gallery'){ 
            selectedWP = <Gallery items={this.state.items} 
            layout={this.state.webpartLayout} 
            moreLink={this.state.webpartLink}
            moreTitle={this.state.webpartLinkTitle}
            mobile={this.state.mobile}
            slidesToShow={this.state.webpartLayout==='first' || this.state.tablet ? 5 : 5}  />
        }
        else if(this.state.webpartType=='Footer'){
            selectedWP = 
                <Footer items={this.state.items}/>
           
        }       
        else if(this.state.webpartType=='Faq'){
            selectedWP =<Faq items={this.state.items} 
                WpId={this.state.WpId}
                layout={this.state.webpartLayout}
                type={this.state.webpartType}
                handleUserKeypress = {this.handleUserKeypress}/>
        }
        else if(this.state.webpartType=='News'){
            selectedWP =<News items={this.state.items} 
                WpId={this.state.WpId}
                layout={this.state.webpartLayout}
                type={this.state.webpartType}
                limit={this.state.webPartNumber}
                moreTitle={this.state.webpartLinkTitle}
                moreLink={this.state.webpartLink} 
                mobile={this.state.mobile}
                handleUserKeypress = {this.handleUserKeypress}/>
        }
        else if(this.state.webpartType=='Form'){
            selectedWP =<Form items={this.state.items} 
                WpId={this.state.WpId}
                layout={this.state.webpartLayout}
                type={this.state.webpartType}
                moreTitle={this.state.webpartLinkTitle} 
                handleUserKeypress = {this.handleUserKeypress}/>
        }
        else if(this.state.webpartType=='Event'){
            
            selectedWP =<Event items={this.state.items} 
                WpId={this.state.WpId}
                layout={this.state.webpartLayout}
                type={this.state.webpartType}
                moreTitle={this.state.webpartLinkTitle}
                moreLink={this.state.webpartLink} 
                mobile={this.state.mobile}
                handleUserKeypress = {this.handleUserKeypress}/>
        }
        else if(this.state.webpartType=='Links'){

            let links= <Links items={this.state.items} 
            moreLink={this.state.webpartLink} 
            moreTitle={this.state.webpartLinkTitle} 
            layout={this.state.webpartLayout} 
            modText={this.state.webpartText} /> 
            selectedWP = (<div className="container"><div className="row">
                {links}
            </div> </div>
            )
        }
        else if(this.state.webpartType=='Collections'){
            let collections= <Collections items={this.state.items} 
            moreLink={this.state.webpartLink} 
            moreTitle={this.state.webpartLinkTitle} 
            layout={this.state.webpartLayout} 
            modText={this.state.webpartText} /> 
            selectedWP = (<div className="container"><div className="row">
                {collections}
            </div> </div>
            )
        }
        else if(this.state.webpartType=='Icons'){
            let amount = this.state.items.length
            let icons=this.state.items.map((item,index) => (
                <Icons data={item} 
                layout={this.state.webpartLayout}  
                key={"Icons_"+index}
                mobile={this.state.mobile}
                amount={amount}
                />
            )) 
            selectedWP = (<div className="container"><div className="row">
                {icons}
                </div></div>
            )
        }
        else if(this.state.webpartType=='ContactUs'){
            selectedWP =<ContactUs items={this.state.items} 
            WpId={this.state.WpId}
            layout={this.state.webpartLayout}
            type={this.state.webpartType}
            siteUrl={this.props.webPartProperties.site}
            title={this.props.webPartProperties.title}
            mailTo={this.props.webPartProperties.ModText}
            handleUserKeypress = {this.handleUserKeypress}  />
        }
        else if(this.state.webpartType=='Tabs'){ 
            selectedWP = <Tabs items={this.state.items} 
            layout={this.state.webpartLayout} 
            moreLink={this.state.webpartLink} 
            moreTitle={this.state.webpartLinkTitle} 
            mobile={this.state.mobile}
            type={this.state.webpartType}
            WpId={this.state.WpId} />;
        } 
        return (
            <div className={"modWPContainer " + this.state.webpartType +'_'+this.state.webpartLayout}>
            {this.state.webpartTitle != null && this.state.webpartTitle != '' &&
                <h2>{this.state.webpartTitle}</h2>
            }
                {selectedWP}
            </div>
        );
    }
}
export default ModWebParts;
